(function () {
  'use strict';

  class HeroSlideshow {
    constructor(element) {
      this.element = element;
      this.slides = Array.from(element.querySelectorAll('.hero-slideshow__slide'));
      this.currentIndex = 0;
      this.autoplay = element.dataset.autoplay === 'true';
      this.speed = parseInt(element.dataset.autoplaySpeed, 10) || 5000;
      this.timer = null;
      this.progressBar = element.querySelector('[data-progress-bar]');
      this.currentCounter = element.querySelector('[data-current-slide]');
      this.prevBtn = element.querySelector('[data-prev-slide]');
      this.nextBtn = element.querySelector('[data-next-slide]');

      if (this.slides.length <= 1) return;

      this.bindEvents();
      this.goTo(0);
      if (this.autoplay) this.startAutoplay();
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.goTo(this.currentIndex - 1);
          this.resetAutoplay();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.goTo(this.currentIndex + 1);
          this.resetAutoplay();
        });
      }

      let touchStartX = 0;
      let touchStartY = 0;
      let touchStartedAt = 0;

      this.element.addEventListener('touchstart', (event) => {
        if (!event.touches.length) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        touchStartedAt = Date.now();
      }, { passive: true });

      this.element.addEventListener('touchend', (event) => {
        if (!event.changedTouches.length) return;
        if (event.target.closest('a, button, input, select, textarea')) return;

        const deltaX = event.changedTouches[0].clientX - touchStartX;
        const deltaY = event.changedTouches[0].clientY - touchStartY;
        const elapsed = Date.now() - touchStartedAt;

        if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
          this.goTo(this.currentIndex + (deltaX < 0 ? 1 : -1));
          this.resetAutoplay();
        } else if (Math.abs(deltaX) < 12 && Math.abs(deltaY) < 12 && elapsed < 450) {
          this.goTo(this.currentIndex + 1);
          this.resetAutoplay();
        }
      }, { passive: true });
    }

    goTo(index) {
      if (index < 0) index = this.slides.length - 1;
      if (index >= this.slides.length) index = 0;

      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      this.currentIndex = index;

      if (this.currentCounter) {
        this.currentCounter.textContent = index + 1;
      }

      if (this.progressBar) {
        const progress = ((index + 1) / this.slides.length) * 100;
        this.progressBar.style.width = progress + '%';
      }
    }

    startAutoplay() {
      this.timer = setInterval(() => {
        this.goTo(this.currentIndex + 1);
      }, this.speed);
    }

    resetAutoplay() {
      if (!this.autoplay) return;
      clearInterval(this.timer);
      this.startAutoplay();
    }
  }

  class SeamlessMarquee {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('.brand-card-marquee__track');
      this.speed = 32;
      this.offset = 0;
      this.lastTime = 0;
      this.frame = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.track || !this.track.firstElementChild || this.reducedMotion || element.dataset.marqueeInitialized === 'true') return;

      element.dataset.marqueeInitialized = 'true';
      this.tick = this.tick.bind(this);
      this.handleVisibility = this.handleVisibility.bind(this);
      document.addEventListener('visibilitychange', this.handleVisibility);
      this.frame = requestAnimationFrame(this.tick);
    }

    handleVisibility() {
      this.lastTime = 0;
    }

    tick(time) {
      if (this.lastTime) {
        const elapsed = Math.min(time - this.lastTime, 50);
        this.offset += this.speed * elapsed / 1000;

        let firstCard = this.track.firstElementChild;
        const styles = window.getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        let firstCardWidth = firstCard.getBoundingClientRect().width + gap;

        while (firstCard && firstCardWidth > 0 && this.offset >= firstCardWidth) {
          this.offset -= firstCardWidth;
          this.track.appendChild(firstCard);
          firstCard = this.track.firstElementChild;
          firstCardWidth = firstCard.getBoundingClientRect().width + gap;
        }

        this.track.style.transform = 'translate3d(-' + this.offset + 'px, 0, 0)';
      }

      this.lastTime = time;
      this.frame = requestAnimationFrame(this.tick);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    function addVariantToCart(variantId, button, fallbackForm) {
      button.disabled = true;
      var cartCounts = Array.from(document.querySelectorAll('[data-cart-count]'));
      var previousCounts = cartCounts.map(function (count) { return count.textContent; });
      cartCounts.forEach(function (count) {
        var current = parseInt(count.textContent, 10) || 0;
        count.textContent = current + 1;
        count.classList.remove('hidden');
      });
      button.classList.add('is-added');
      return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to add item');
        return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js');
      }).then(function (response) { return response.json(); }).then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (count) { count.textContent = cart.item_count; count.classList.remove('hidden'); });
        button.setAttribute('aria-label', 'Added to cart');
        setTimeout(function () { button.classList.remove('is-added'); button.disabled = false; }, 900);
      }).catch(function () {
        cartCounts.forEach(function (count, index) { count.textContent = previousCounts[index]; if (!(parseInt(previousCounts[index], 10) > 0)) count.classList.add('hidden'); });
        button.classList.remove('is-added');
        if (fallbackForm) fallbackForm.submit(); else button.disabled = false;
      });
    }

    document.querySelectorAll('[data-quick-add-id]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault(); event.stopPropagation();
        addVariantToCart(button.dataset.quickAddId, button, null);
      });
    });

    document.querySelectorAll('[data-quick-add]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('button[type="submit"]');
        if (!button || button.disabled) return;
        addVariantToCart(form.querySelector('[name="id"]').value, button, form);
      });
    });

    document.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      var prefetched = false;
      function prefetchProduct() {
        if (prefetched) return; prefetched = true;
        var preload = document.createElement('link'); preload.rel = 'prefetch'; preload.href = link.href; document.head.appendChild(preload);
      }
      link.addEventListener('mouseenter', prefetchProduct, { once: true });
      link.addEventListener('touchstart', prefetchProduct, { once: true, passive: true });
    });

    document.querySelectorAll('[data-section-type="hero-slideshow"]').forEach(function (el) {
      new HeroSlideshow(el);
    });

    document.querySelectorAll('.brand-card-marquee').forEach(function (el) {
      new SeamlessMarquee(el);
    });

    document.querySelectorAll('[data-category-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const menu = trigger.closest('.site-header__categories');
        const isOpen = menu.classList.toggle('is-submenu-open');
        trigger.setAttribute('aria-expanded', String(isOpen));
      });
    });

    document.querySelectorAll('[data-basics-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const submenu = trigger.closest('.site-header__submenu');
        const isOpen = submenu.classList.toggle('is-basics-open');
        trigger.setAttribute('aria-expanded', String(isOpen));
      });
    });

    document.querySelectorAll('.site-header__menu-item--categories').forEach(function (item) {
      const toggle = item.querySelector('[data-categories-toggle]');
      const categoryTrigger = item.querySelector('[data-category-trigger]');
      const categoriesMenu = item.querySelector('.site-header__categories');
      const basicsTrigger = item.querySelector('[data-basics-trigger]');
      const basicsSubmenu = item.querySelector('.site-header__submenu');

      if (!toggle) return;

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        const isOpen = item.classList.toggle('is-dropdown-open');
        toggle.setAttribute('aria-expanded', String(isOpen));

        if (!isOpen && categoriesMenu) {
          categoriesMenu.classList.remove('is-submenu-open');
          if (categoryTrigger) categoryTrigger.setAttribute('aria-expanded', 'false');
          if (basicsSubmenu) basicsSubmenu.classList.remove('is-basics-open');
          if (basicsTrigger) basicsTrigger.setAttribute('aria-expanded', 'false');
        }
      });

      item.addEventListener('mouseleave', function () {
        item.classList.remove('is-dropdown-open');
        toggle.setAttribute('aria-expanded', 'false');

        if (categoriesMenu) categoriesMenu.classList.remove('is-submenu-open');
        if (categoryTrigger) categoryTrigger.setAttribute('aria-expanded', 'false');
        if (basicsSubmenu) basicsSubmenu.classList.remove('is-basics-open');
        if (basicsTrigger) basicsTrigger.setAttribute('aria-expanded', 'false');
      });
    });

    document.querySelectorAll('[data-section-type="header"]').forEach(function (header) {
      const menuToggle = header.querySelector('[data-mobile-menu-toggle]');
      if (!menuToggle) return;

      menuToggle.addEventListener('click', function () {
        const isOpen = header.classList.toggle('is-mobile-menu-open');
        menuToggle.setAttribute('aria-expanded', String(isOpen));
        menuToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      });

      header.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          header.classList.remove('is-mobile-menu-open');
          menuToggle.setAttribute('aria-expanded', 'false');
          menuToggle.setAttribute('aria-label', 'Open menu');
          menuToggle.focus();
        }
      });
    });
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('[data-section-type="hero-slideshow"]')) {
        new HeroSlideshow(event.target.querySelector('[data-section-type="hero-slideshow"]'));
      }
      var marquee = event.target.querySelector('.brand-card-marquee');
      if (marquee) new SeamlessMarquee(marquee);
    });
  }

  function initializeWelcomePopup() {
    var path = window.location.pathname.toLowerCase();
    if (path.indexOf('/cart') !== -1 || path.indexOf('cart.html') !== -1 || path.indexOf('checkout') !== -1) return;

    var popup = document.querySelector('[data-welcome-popup]');
    if (!popup && path.indexOf('/preview/') !== -1) {
      popup = document.createElement('aside');
      popup.className = 'welcome-popup';
      popup.hidden = true;
      popup.setAttribute('data-welcome-popup', '');
      popup.setAttribute('aria-label', 'Welcome discount');
      popup.innerHTML = '<button type="button" class="welcome-popup__close" data-welcome-close aria-label="Close promotion">×</button><img class="welcome-popup__image" src="../assets/welcome-popup-transparent.png" alt="Get 10% off your first order. Use code WELCOME10"><button type="button" class="welcome-popup__copy" data-welcome-copy data-code="WELCOME10"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="2"></rect><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0 2 2v8a2 2 0 0 0 2 2h2"></path></svg><span data-copy-label>Copy</span></button><button type="button" class="welcome-popup__ok" data-welcome-ok aria-label="Confirm promotion">OK</button><label class="welcome-popup__dont-show"><input type="checkbox" data-welcome-dont-show><span>Don\'t show again</span></label>';
      document.body.appendChild(popup);
    }
    if (!popup) return;

    var closeButton = popup.querySelector('[data-welcome-close]');
    var copyButton = popup.querySelector('[data-welcome-copy]');
    var copyLabel = popup.querySelector('[data-copy-label]');
    var okButton = popup.querySelector('[data-welcome-ok]');
    var dontShow = popup.querySelector('[data-welcome-dont-show]');
    var dismissedKey = 'pinkPlainWelcomeDismissedForVisit';
    var closedForPage = false;
    try { var navigationEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0]; if (navigationEntry && navigationEntry.type === 'reload') sessionStorage.removeItem(dismissedKey); } catch (error) {}
    function isDismissed() { try { return sessionStorage.getItem(dismissedKey) === 'true'; } catch (error) { return false; } }
    function showPopup() {
      if (isDismissed() || closedForPage) return;
      popup.hidden = false;
      popup.removeAttribute('hidden');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { popup.classList.add('is-visible'); });
      });
    }
    function hidePopup() { popup.classList.remove('is-visible'); setTimeout(function () { popup.hidden = true; }, 550); }
    function copyCode() {
      var code = copyButton.dataset.code;
      var fallback = function () { var input = document.createElement('textarea'); input.value = code; document.body.appendChild(input); input.select(); document.execCommand('copy'); input.remove(); };
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).catch(fallback); else fallback();
      copyLabel.textContent = 'Copied!';
      setTimeout(function () { copyLabel.textContent = 'Copy'; }, 1800);
    }
    closeButton.addEventListener('click', function () { closedForPage = true; hidePopup(); });
    copyButton.addEventListener('click', copyCode);
    okButton.addEventListener('click', function () {
      if (dontShow.checked) { try { sessionStorage.setItem(dismissedKey, 'true'); } catch (error) {} }
      closedForPage = true;
      hidePopup();
    });
    var interval = 60000;
    showPopup();
    setInterval(showPopup, interval);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWelcomePopup);
  } else {
    initializeWelcomePopup();
  }
})();
